// 채권채무 목록 - "다음 예정일 1개 + 펼침" 요약(설계문서 4장 영향범위 표, 2026-10-21).
// DataGrid(Community edition)는 행 펼침(detail panel)이 Pro 전용이라, 여기서는 다이얼로그로
// "펼쳐서 전체 계획 보기"를 구현한다 - 조회 전용(수정은 OrderBillReviewPanel "계획관리").
import React, { useEffect, useState } from 'react';
import {
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LockIcon from '@mui/icons-material/Lock';
import * as billCollectPlanApi from '../../lib/api/billCollectPlan';

const fmt = (value) => {
  const n = Number(String(value ?? '').replace(/,/g, ''));
  return Number.isFinite(n) ? n.toLocaleString('ko-KR') : '0';
};

const STATUS_COLOR = { '예정': 'default', '지연': 'error', '부분수금': 'warning', '완료': 'success' };

export default function BillPlanSummaryDialog({ open, onClose, invUuid, invNo }) {
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    if (open && invUuid) {
      setLoading(true);
      billCollectPlanApi.getPlans(invUuid)
        .then((res) => setPlans(res?.data?.data || []))
        .finally(() => setLoading(false));
    } else if (!open) {
      setPlans([]);
    }
  }, [open, invUuid]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        계획 - {invNo || ''}
        <IconButton size="small" onClick={onClose} sx={{ ml: 'auto' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>계획명</TableCell>
                <TableCell>계획일</TableCell>
                <TableCell align="right">계획금액</TableCell>
                <TableCell align="right">잔액</TableCell>
                <TableCell>상태</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {plans.map((p) => (
                <TableRow key={p.planUuid}>
                  <TableCell>{p.planNm || '-'}</TableCell>
                  <TableCell>{p.planDt || '-'}</TableCell>
                  <TableCell align="right">{fmt(p.planAmt)}</TableCell>
                  <TableCell align="right">{fmt(p.remainAmt)}</TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      icon={p.locked ? <LockIcon fontSize="small" /> : undefined}
                      label={p.status || '예정'}
                      color={STATUS_COLOR[p.status] || 'default'}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  );
}
